import { Injectable } from '@angular/core';
import { IStringRecord } from '../../../../../type_definitions/datatypes';

export interface IMemberFeeFrequency extends IStringRecord {
  value:string;
}

@Injectable()
export class BPProfilesContractDataService {
  public get feeFrequencies():IMemberFeeFrequency[] {
    return [
      { id: 'MONTH', value: 'BPPROFILES.CONTRACT.FREQUENCY.MONTH' },
      { id: 'QUARTER', value: 'BPPROFILES.CONTRACT.FREQUENCY.QUARTER' },
      { id: 'YEAR', value: 'BPPROFILES.CONTRACT.FREQUENCY.YEAR' },
      { id: 'BIANNUAL', value: 'BPPROFILES.CONTRACT.FREQUENCY.BIANNUAL' }
    ];
  }
}